import { Component, OnInit, ViewChild, ElementRef } from "@angular/core"
import { trigger, transition, animate, style } from "@angular/animations"
import { AppService } from '../../../app.service';
import { MatDialog } from '@angular/material/dialog';import { RecordRepairModalComponent } from '../record-repair-modal/record-repair-modal.component';
import { ChangeImplementJobsiteModalComponent } from '../change-implement-jobsite-modal/change-implement-jobsite-modal.component';
import { ImplementDetails, EquipmentDetails, InspectionDetails, ComponentDetails, ImplementHistory } from '../implement-details/implement-details';
import { ImplementDetailsService } from '../implement-details/implement-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { Http } from '@angular/http';
import { SchematicViewComponent } from '../schematic-view/schematic-view.component';
import { SetupImplementService } from "../setup-implement/setup-implement.service";
import { GenericIdName } from "../setup-implement/setup-implement.model";
import { EquipmentDetailsParams } from "../setup-equipment/setup-equipment.model";
import { DomSanitizer } from "@angular/platform-browser";
import { ImplementForEquipmentDetails, ImplementForEquipmentDetailsDFI, OBSActionHistoryDFI } from "../equipment-details/equipment-details.model";
import { GETChangeJobsiteComponent } from "../equipment-details/components/change-jobsite/change-jobsite.component";
import { AppUris } from "../entities/app-config/model";
import { EquipmentDetailsService } from "../equipment-details/equipment-details.service";
import { UserService } from "../../../../app/shared/services/user.service";
import { DigitalFormService } from "../digital-form-fill/digital-form.service";
import { EnablePreferenceTasksVM } from "../../preferences/models/preferences.model";
import { PreferencesService } from "../../preferences/preferences.service";

@Component({
  selector: 'app-dfi-implement-details',
  templateUrl: './dfi-implement-details.component.html',
  styleUrls: ['./dfi-implement-details.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
        transition(':enter', [
            style({ transform: 'translateY(25%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        transition(':leave', [
            style({ transform: 'translateY(0)', opacity: 1 }),
            animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
        ])
    ]
    )]
})
export class DfiImplementDetailsComponent implements OnInit {
  @ViewChild('btnStatusChange') statusChange: ElementRef;
  //pageTitle: string;// = "BKT0001 Details (Excavator Bucket)";
  //pageSubTitle: string = "Record and view data about this implement here. "; // Will need to make this dynamic

  implement: ImplementDetails = new ImplementDetails();
  equipment: EquipmentDetails = new EquipmentDetails();
  inspections: InspectionDetails[] = [];
  getComponents: ComponentDetails[] = [];
  implementHistory: ImplementHistory[] = [];

  // Toggles to show or hide different components.
  showImplement: boolean = false;
  showEquipment: boolean = false;
  showInspections: boolean = false;
  showComponents: boolean = false;
  showHistory: boolean = false;
  showChangeJobsiteModal: boolean = false;
  showRemoveImplementModal: boolean = false;
  showAttachImplementModal: boolean = false;
  showImplementStatusModal: boolean = false;
  showRepairOrReplaceModal: boolean = false;

  implementId: number;

  implementStatusText: string = "";
  implementStatusDesc: string = "";

  currency_symbol: string = "$";
  unit_life: string = "hrs";

  // Define eval colour thresholds.
  THRESHOLD_EVAL_A: number = 30;
  THRESHOLD_EVAL_B_MAX: number = 60;
  THRESHOLD_EVAL_B_MIN: number = 30;
  THRESHOLD_EVAL_C_MAX: number = 80;
  THRESHOLD_EVAL_C_MIN: number = 60;

  dateParser: OrdinalDateParse = new OrdinalDateParse();

  GETUri: string = "";

  wearStyleId: number;
  makeList: GenericIdName[] = [];
  loading: boolean = false
  equipmentDetails: EquipmentDetailsParams;
  CustomerId: number;
  //inspectionDetails: InspectionHistoryDetails[];
  ImplementForEquipmentDetails_: ImplementForEquipmentDetailsDFI[] = [];
  ImplementForEquipmentDetails:ImplementForEquipmentDetails[]=[];
  AssetDetailsHistroy: ImplementForEquipmentDetails;
  equipmentId:number;
  appUris: AppUris;
  isJobRoleDefault: boolean = true;

  AssetDetailsHistroyDFI: ImplementForEquipmentDetails[]=[]; 

  constructor(private route: ActivatedRoute, private _appService: AppService, public changeStatusModal: MatDialog,
      public attachImplementModal: MatDialog, public removeImplementModal: MatDialog,
      private _moduleService: ImplementDetailsService, public recordRepairModal: MatDialog, public recordReplaceModal: MatDialog,
      public changeImplementJobsiteModal: MatDialog, private http: Http, public schematicViewComponent: MatDialog,
      private _implementService: SetupImplementService, private _router: Router, private _user: UserService,
      private _sanitizer: DomSanitizer, private _equipmentDetailsService: EquipmentDetailsService,private _formService:DigitalFormService,
      private readonly _pref: PreferencesService,) { }
    
  ngOnInit() {

      this._appService.setPageTitle('Field Inspection Implement Details');
   

      this.route.params.subscribe(params => {
          this.equipmentId = +params['equipmentId'];

          if (this.equipmentId) {
              this.initialise();
          }
      });
      this._appService.getAppUris().subscribe(result => { this.appUris = result; });
  }

  initialise() {
      this.LoadJobRoles();
      this.loadEquipmentDetails();
      this.loadMakes();
      this.loadImplementDetails();
      //this.loadDFIComponentLinkHistroy();
      //this.loadImplementDetailsHistroy();
      //this.loadImplementHistoryDetails();
      //this.loadCycleDetails();
//this.loadImplementDetailsHistroyDFI()
this.GetPreferenceTaskList()
this.GetDFIInspectionHistory()

  }



  LoadJobRoles() {
      this._user.getUserJobRoles().subscribe(roles => {
          roles.forEach(r => {
              switch (r.Name) {
                  case 'Inspectors':
                      this.isJobRoleDefault = false;
                      break;
                  case 'Interpreters':
                      this.isJobRoleDefault = false;
                      break;
                  case 'Super User':
                      this.isJobRoleDefault = false;
                      break;
                  case 'Administrator':
                      this.isJobRoleDefault = false;
                      break;
                case 'Customer Admin':
                    this.isJobRoleDefault = false;
                    break;
              }
          });

      })
  }

  // Implement Makes
  loadMakes() {
      this._implementService.GetImplementMakes().subscribe(r => {
          this.makeList = r;
      });
  }

  loadEquipmentDetails() {
    this._equipmentDetailsService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
          this.equipmentDetails = equipment;
          //this.loadObservationPointsForImplement();
          this.CustomerId = this.equipmentDetails.CustomerId;

          this.SMU = this.equipmentDetails.Smu;

          //console.log(this.equipmentDetails)
        
        
      });

  }

  SMU: number = -1;

  loadImplementDetails() {

      this.loading = true;
      this._equipmentDetailsService.GetImplementsAndSchematicsForDFI(this.equipmentId).subscribe(details => {
          this.ImplementForEquipmentDetails = details;
          this.loading = false

      });

  }
// Componenthistroy :GETDashboardComponentHistroyInspectionVM[];
//   loadDFIComponentLinkHistroy(){
//     this._formService.GetDFIComponentHistroyForEquipment(this.equipmentId).subscribe(res=>{
//         console.log("test__",res)
//         this.Componenthistroy = res;
//     })
//   }

  loadImplementDetailsHistroy() {

      this.loading = true;
      this._moduleService.GetAssestDetailHistroyInfo(this.implementId).subscribe(details => {
          this.AssetDetailsHistroy = details;
          this.loading = false


      });

  }
 
  GetAssestDetailHistroyInfoDFI

  getImage(image: string) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  getEvalClass(wornPct: number) {
      if (wornPct <= 30) {
          return " WornPctCell evalColorA";
      }
      else if ((wornPct > 30) && (wornPct <= 60)) {
          return " WornPctCell evalColorB";
      }
      else if ((wornPct > 60) && (wornPct <= 80)) {
          return " WornPctCell evalColorC";
      }
      else if (wornPct > 80) {
          return "WornPctCell evalColorX";
      }
      return " WornPctCell noEval";
  }

  getEvalCode(evalcode: string) {
      if (evalcode == 'A') {
          // return "evalColorACode";
          return " WornPctCell evalColorA";
      }
      else if (evalcode == 'B') {
          //return "evalColorBCode";
          return " WornPctCell evalColorB";
      }
      else if (evalcode == 'C') {
          //return "evalColorCCode";
          return " WornPctCell evalColorC";
      }
      else if (evalcode == 'X') {
          //return "evalColorXCode";
          return "WornPctCell evalColorX";
      }
      return " noEvalCode";
  }





  //open change jobsite equipment

  openChangeJobsite() {
      const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
          panelClass: 'removeModalOverflow',
          data: {
              equipmentId: this.equipmentDetails.equipmentId,
              customerId: this.equipmentDetails.CustomerId
          }
      });

      dialogRef.afterClosed().subscribe(newJobsiteName => {
          if (newJobsiteName == null || newJobsiteName === undefined)
              return;
          if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
              // this.equipmentDetails.JobsiteName = newJobsiteName;
              this.loadEquipmentDetails();
          }
      });
  }


  //open chnage jobsite Inventory
  openChangeJobsiteInventory() {
      const dialogRef = this.changeStatusModal.open(GETChangeJobsiteComponent, {
          panelClass: 'removeModalOverflow',
          data: {
              implementId: this.implementId,
          }
      });

      dialogRef.afterClosed().subscribe(newJobsiteName => {
          if (newJobsiteName == null || newJobsiteName === undefined)
              return;
          if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
              // this.equipmentDetails.JobsiteName = newJobsiteName;
              this.loadEquipmentDetails();
          }
      });
  }






 





  openRecordRepairModal(id, name) {
      let openRecordRepairModalRef = this.recordRepairModal.open(RecordRepairModalComponent, {
          width: '550px',
          data: {
              jobsiteId: this.implement.jobsiteId,
              jobsiteName: this.implement.jobsite,
              componentId: id,
              componentName: name
          }
      });
      openRecordRepairModalRef.afterClosed().subscribe(() => {
          //this.reloadDetails();
      })
  }


  openChangeImplementJobsiteModal() {
      let changeImplementJobsiteModalRef = this.changeImplementJobsiteModal.open(ChangeImplementJobsiteModalComponent, {
          width: '550px',
          data: { implementId: this.implementId }
      });
      changeImplementJobsiteModalRef.afterClosed().subscribe(() => {
          // this.reloadDetails();
      });
  }

  // Determine the eval colours to use.
  determineEvalColour(val) {
      if (val <= this.THRESHOLD_EVAL_A) {
          return 'eval-a';
      } else if ((val > this.THRESHOLD_EVAL_B_MIN) && (val <= this.THRESHOLD_EVAL_B_MAX)) {
          return 'eval-b';
      } else if ((val > this.THRESHOLD_EVAL_C_MIN) && (val <= this.THRESHOLD_EVAL_C_MAX)) {
          return 'eval-c';
      } else {
          return 'eval-x';
      }
  }

  // openInspection(id) {
  //     var uri = 'http://' + this.GETUri + '/GET/InspectionDetails.aspx' + '?i=' + id;
  //     window.open(uri, '');
  // }

  mouseOverStatus() {
      this.statusChange.nativeElement.style.background = "#85888B";
  }

  mouseLeaveStatus() {
      this.statusChange.nativeElement.style.background = "#1D2F36";
  }

  openSchematic(): void {
      let schematicViewModalRef = this.schematicViewComponent.open(SchematicViewComponent, {
          width: '720px',
          height: '695px',
          data: { implementId: this.implementId }
      });
      schematicViewModalRef.afterClosed().subscribe(() => {

      });
  }

  
  loadImplementDetailsHistroyDFI() {

    this.loading = true;
    this._equipmentDetailsService.GetAssestDetailHistroyInfoDFI(this.equipmentId).subscribe(details => {
        this.AssetDetailsHistroyDFI = details;
        console.log("AssetDetailsHistroyDFI",this.AssetDetailsHistroyDFI)
        this.loading = false


    });

}

EnablePreference:EnablePreferenceTasksVM
GetPreferenceTaskList(){
    this._pref.getPreferenceTaskListForLoggedUser().subscribe(res=>{
    this.EnablePreference=res
    })
}
 inspectionDetailsforDFI:OBSActionHistoryDFI[]
GetDFIInspectionHistory(){
    this._equipmentDetailsService.GetDFIInspectionHistory(this.equipmentId).subscribe(res=>{
        this.inspectionDetailsforDFI=res
    })
}

openLink(formUploadID, UploadID){
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
            this._router.navigate(['/digitalform/fill', formUploadID, UploadID]);
        }else{             
            window.open('/digitalform/fill/' + formUploadID + '/' + UploadID, '_blank')
         
        }
    });
}



getStatusCode(status: number) {
    if (status == 1) {
        // In progress;
        return "  InspectionInProgressCode";
    }
    else if (status == 2) {
        //return in review
        return "  InspectionInReviewCode";
    }
    else if (status == 3) {
        //returncompleted
        return "  InspectionCompletedCode";
    }
 
    return " InspectionNotStartedCode";
}
}
